import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { AssetsStore, UserStore, ViewStore } from '@coach-bot/data-access/shared';
import { AuthState } from '@coach-bot/features/auth';
import { ENVIRONMENT_TOKEN, Environment } from '@environment';
import {
  faArrowRightFromBracket,
  faArrowUpRightFromSquare,
  faCalculator,
  faCheckCircle,
  faCircleQuestion,
  faSackDollar,
  faTimes,
  faTowerCell,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import { AbstractComponent } from '@shared/ui';
import { BehaviorSubject, filter, take, takeUntil } from 'rxjs';

enum SubjectView {
  Selector = 'Selector',
  Task = 'Task',
}

@Component({
  selector: 'da-dashboard',
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardComponent extends AbstractComponent {
  readonly assetsPath$: BehaviorSubject<string> = this.assetsStore.assetsPath$;
  readonly loading$: BehaviorSubject<boolean> = this.viewStore.authLoading$;
  readonly subject$ = new BehaviorSubject('Math');
  readonly subjectView$ = new BehaviorSubject<SubjectView>(SubjectView.Task);

  readonly icons = {
    faArrowRightFromBracket,
    faArrowUpRightFromSquare,
    faCalculator,
    faCheckCircle,
    faCircleQuestion,
    faSackDollar,
    faTimes,
    faTowerCell,
    faUser,
  };

  readonly SubjectView = SubjectView;

  constructor(
    private assetsStore: AssetsStore,
    private authState: AuthState,
    @Inject(ENVIRONMENT_TOKEN) private environment: Environment,
    private userStore: UserStore,
    private viewStore: ViewStore
  ) {
    super();

    this.userStore.userId$.pipe(takeUntil(this.destroyed$), filter(userId => !!userId), take(1)).subscribe((userId: string) => {
      this.authState.loadUserDetails(userId);
    });
  }

  openDashboard(): void {
    window.open(this.environment.dashboardUrl, '_blank');
  }

  openSubjectSelector(): void {
    this.subjectView$.next(SubjectView.Selector);
  }

  onSubjectSelected(subject: string): void {
    this.subject$.next(subject);
    this.subjectView$.next(SubjectView.Task);
  }

  onSignOut(): void {
    this.authState.signOut();
  }
}
